<template>
  <section class="product-page-header">
    <div class="left">
      <slot name="left">
        <h3 class="header-title text-primary clearfix">
          <span class="title-icon">
            <svg-icon :iconClass="$route.meta.iconSvg"></svg-icon>
          </span>
          {{ $route.meta.title }}
        </h3>
      </slot>
    </div>
    <div class="right">
      <!-- <el-button-group>
        <template v-for="tab in tabs">
          <el-button
            :type="tab.routeName == $route.name ? 'primary' : ''"
            :key="tab.routeName"
            @click="handleTab(tab)"
            size="small"
            >{{ tab.name }}</el-button
          >
        </template>
      </el-button-group> -->
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      tabs: [
        {
          name: "案例管理",
          routeName: "EngineeringCaseList",
          disabled: false,
        },
        {
          name: "区域",
          routeName: "AreasList",
          disabled: false,
        },
        {
          name: "设计方",
          routeName: "DesignersList",
          disabled: false,
        },
        {
          name: "开发商",
          routeName: "DevelopersList",
          disabled: false,
        },

        {
          name: "类型",
          routeName: "TypesList",
          disabled: false,
        },
      ],
    };
  },
  methods: {
    handleTab(item) {
      this.$router.push({
        name: item.routeName,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.product-page-header {
  box-sizing: border-box;
  padding: 10px 15px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  .left {
    flex: 1;
    text-align: left;
    .header-title {
      font-size: 18px;
      .title-desc {
        font-size: 13px;
        color: #989898;
        text-align: left;
        padding-left: 15px;
      }
    }
  }
  .right {
    flex: 1;
    text-align: right;
  }
}
</style>
